<template>
  <div class="yxtbiz-rank-list__two-columns">
    <!-- 榜单名称 -->
    <rank-title
      v-if="
        !styleObject.hideHeader &&
          (!styleObject.hideTitle ||
            (styleObject.hideTitle &&
            (styleObject.hideMyRank || 
            (!rankData.rankList || !rankData.rankList.length))))
      "
      @changeDate="$emit('changeDate', $event)"
      :class="{
        'yxtbiz-rank-list__two-columns-title':
          !styleObject.hideHeader &&
          (!styleObject.hideTitle || titleObj.showDate)
      }"
      ><div slot="title"><slot name="title"></slot></div
    ></rank-title>
    <div
      :style="{ height: height ? height - 88 + 'px' : 'auto' }"
      :class="{
        'yxtbiz-rank-list__two-columns-no-data': height && (!rankData.rankList || !rankData.rankList.length)
      }"
    >
      <yxtf-scrollbar
        v-if="rankData.rankList && rankData.rankList.length"
        fit-height
        ref="scrollBox"
      >
        <!-- 我的排名 -->
        <my-rank
          v-if="!styleObject.hideMyRank && titleObj.objectCode === 'user'"
          :myRankData="rankData.myRankData"
          :styleType="2"
          :class="[styleObject.showStyle === 1 ? 'mb16': 'mb32']"
          @changeDate="$emit('changeDate', $event)"
        ><div slot="title"><slot name="title"></slot></div></my-rank>
        <!-- 横排式 前三名 -->
        <horizontal-head
          v-if="styleObject.showStyle === 2"
          class="mt32"
          :rank-data="rankData.rankList.slice(0, 3)"
        />
        <!-- 排名列表 -->
        <div class="flex">
          <div class="flex-1 yxtbiz-rank-list__two-columns-first-line">
            <div v-for="(item, index) of firstLine" :key="index">
              <row-item
                :rowData="item"
              />
            </div>
          </div>
          <div class="flex-1 yxtbiz-rank-list__two-columns-second-line">
            <div v-for="(item, index) of secondLine" :key="index">
              <row-item
                :rowData="item"
              />
            </div>
          </div>
        </div>
      </yxtf-scrollbar>
      <div v-else>
        <div v-if="initFlag < 1">
          <div
            v-if="errorTip === 'pc_biz_rank_calculating'"
            class="flex yxtbiz-rank-list__two-columns-calculating"
          >
            <yxtf-svg width="16px" height="16px" icon-class="loading" />
            <span
              class="
                standard-size-14
                text-8c
                yxtbiz-rank-list__two-columns-calculating-tip
              "
              >{{ $t('pc_biz_rank_calculating') }}</span
            >
          </div>
          <yxtf-empty v-else size="small" :empty-text="$t(errorTip)">
          </yxtf-empty>
        </div>
       </div>
    </div>
  </div>
</template>
<script>
import rowItem from '../component/rowitem.vue';
import horizontalHead from '../component/horizontalHead.vue';
import myRank from '../component/myRank.vue';
import rankTitle from '../component/rankTitle.vue';

export default {
  components: {
    rowItem,
    horizontalHead,
    myRank,
    rankTitle
  },
  props: {
    // 榜单数据
    rankData: {
      type: Object,
      default: () =>{}
    },
    // 排行榜高度
    height: {
      type: Number,
      default: 0
    },
    // 获取榜单数据的接口报错文案
    errorTip: {
      type: String,
      default: ''
    },
    // 记录是否调用过接口
    initFlag: {
      type: Number,
      default: 2
    }
  },
  inject: ['styleFun', 'titleFun'],
  computed: {
    // styleType 样式类型: 1 一列式、2 两列式, showStyle 展示样式: 1 列表式、2 横排式
    styleObject() {
      return this.styleFun();
    },
    sliceNum() {
      return this.styleObject.showStyle === 2 ? 3 : 0;
    },
    // 榜单名称数据
    titleObj() {
      return this.titleFun();
    },
    // 第一列数据
    firstLine() {
      return this.rankData.rankList
        ? this.rankData.rankList.slice(
          this.sliceNum,
          Math.ceil((this.rankData.rankList.length - this.sliceNum) / 2) +
              this.sliceNum
        )
        : [];
    },
    // 第二列数据
    secondLine() {
      return this.rankData.rankList
        ? this.rankData.rankList.slice(
          Math.ceil((this.rankData.rankList.length - this.sliceNum) / 2) +
              this.sliceNum
        )
        : [];
    }
  },
  methods: {
    // 页面刷新后，滚动到顶部
    scrollToTop() {
      this.$refs.scrollBox && this.$refs.scrollBox.$refs.wrap && (this.$refs.scrollBox.$refs.wrap.scrollTop = 0);
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
